var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionHelp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 26 26",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.173 -.173)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(1.173 1.173)",
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: "2px"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v2",
  transform: "translate(13.173 19.173)",
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: "2px"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.058 19.173v-2.122a2.86 2.86 0 0 1 1.8-2.655 3.6 3.6 0 0 0 2.26-3.339A4.06 4.06 0 0 0 15.058 7 4.06 4.06 0 0 0 11 11.058",
  transform: "translate(-1.884 -1.131)",
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: "2px"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/questionHelp.adc6a32a27fceb3e8bfd642e10129491.svg";